import { css, jsx } from '@emotion/react';
import { Typography } from '@zapier/design-system';

const styles = {
  title: css(Object.assign(Object.assign({}, Typography.ParagraphHeader3), { color: "var(--zds-text-default, #413735)", padding: `
      var(--zds-space-6, 0.375rem)
      var(--zds-space-20, 1.25rem)
      var(--zds-space-16, 1rem)
      var(--zds-space-16, 1rem)
    ` }))
};
const SecondaryNavTitle = ({ value, className }) => {
  return jsx("h2", { className, css: styles.title, "data-zds": true }, value);
};

export { SecondaryNavTitle };
//# sourceMappingURL=SecondaryNavTitle.es.js.map
